/**
 * ACL Configuration State Store
 * Tracks pending FreeSWITCH ACL configuration changes
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AclConfigState {
    hasPendingChanges: boolean;
    lastChangeTimestamp: number | null;
    lastAppliedTimestamp: number | null;

    // Actions
    markPendingChanges: () => void;
    clearPendingChanges: () => void;
}

export const useAclConfigStore = create<AclConfigState>()(
    persist(
        (set) => ({
            hasPendingChanges: false,
            lastChangeTimestamp: null,
            lastAppliedTimestamp: null,

            markPendingChanges: () => set({
                hasPendingChanges: true,
                lastChangeTimestamp: Date.now()
            }),

            clearPendingChanges: () => set({
                hasPendingChanges: false,
                lastAppliedTimestamp: Date.now()
            })
        }),
        {
            name: 'acl-config-state'
        }
    )
);
